import * as Sentry from '@sentry/vue';
import {
  useNotifications,
  type NotificationCreateData,
} from '~/stores/notifications';
import { useUserStore } from '~/stores/user';

export function useErrorHandler(
  error: any,
  notification?: NotificationCreateData | false
) {
  if (process.env.NODE_ENV === 'development') {
    console.error(error);
  }

  // error?.response.status === 401 is the axios response for unauthorized
  if (
    error?.response?.status === 401 ||
    error?.data?.httpStatus === 401 ||
    error?.data?.code === 'UNAUTHORIZED'
  ) {
    // For TRPC, we have the error information wrapped under the property "data"
    return;
  }

  const userStore = useUserStore();
  const user = userStore.user;

  let traceId;

  if (user) {
    traceId =
      typeof error === 'string'
        ? Sentry.captureMessage(error, {
            user: {
              id: user._id,
              username: user.name,
            },
          })
        : Sentry.captureException(error, {
            user: {
              id: user._id,
              username: user.name,
            },
          });
  } else {
    traceId =
      typeof error === 'string'
        ? Sentry.captureMessage(error)
        : Sentry.captureException(error);
  }

  if (notification !== false) {
    const notificationStore = useNotifications();

    // Unfortunately, we can not use i18n in here because we are not calling useErrorHandler
    // on the root level of the setup function
    notificationStore.createNotification(
      notification
        ? { ...notification, traceId }
        : {
            type: 'error',
            title: 'Something went wrong',
            message: 'Please contact your Key-Account-Manager.',
            traceId,
          }
    );
  }
}
